module.exports = __webpack_public_path__ + "img/Magnuss44.4113fbce.jpg";